<template>
    <div>
        <a-drawer :title="`Session${$t('web.list' /* Session列表 */)}`" width="85%" placement="right" :closable="true" :visible="visible" @close="handleDrawerClose">
            <a-spin :spinning="loading">
                <a-form class="mb20" :form="form" layout="inline">
                    <a-form-item :label="$t('program.title' /* 标题 */)">
                        <a-input style="width: 150px" v-decorator="['abstract_title']" :placeholder="$t('program.title' /* 标题 */)"></a-input>
                    </a-form-item>
                    <a-form-item :label="$t('program.batch_live_label_hall' /* 会场 */)">
                        <a-select style="width: 150px" :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_hall')" v-decorator="['hall_id']" allowClear>
                            <a-select-option v-for="item in hallList" :key="item.id" :value="item.id">
                                {{ item.meeting_hall }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item :label="$t('program.batch_live_label_date' /* 日期 */)">
                        <a-select style="width: 150px" :placeholder="$t('formConfig.please_select' /* 请选择 */) + $t('program.batch_live_label_date')" v-decorator="['date_id']" allowClear>
                            <a-select-option v-for="item in dateList" :key="item.id" :value="item.id">
                                {{ item.meeting_date }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-button type="primary" @click="handleSearchEvent">{{ $t('web.query' /* 查询 */) }}</a-button>
                    </a-form-item>
                </a-form>

                <!-- 表格 -->
                <div class="t-r mb10">
                    <a-button type="primary" @click="handleBatchUpdate">{{ $t('program.batch_modify' /* 批量修改 */) }}</a-button>
                </div>
                <a-table
                    ref="table"
                    :rowKey="record => record.id"
                    :columns="columns"
                    :data-source="dataSource"
                    :pagination="pagination"
                    @change="handleTableChange"
                    @showSizeChange="handleTableChange"
                    :scroll="{ x: 800 }"
                    :row-selection="{
                        selectedRowKeys: selectedRowKeys,
                        onChange: onSelectChange
                    }"
                >
                    <template slot="starttime_slot" slot-scope="text, record">
                        <div>{{ text }}-{{ record.endtime_slot }}</div>
                    </template>
                </a-table>
            </a-spin>
        </a-drawer>
        <!-- 批量修改弹窗 -->
        <batch-session-update ref="batchSessionUpdate" :dateList="dateList" :hallList="hallList" @closeSessionUpdate="getDataList" />
    </div>
</template>

<script>
import batchSessionUpdate from './batch-session-update-modal.vue';

export default {
    name: 'BatchSessionDrawer',
    props: {
        dateList: {
            type: Array,
            default: () => {
                return [];
            }
        },
        hallList: {
            type: Array,
            default: () => {
                return [];
            }
        }
    },
    components: { batchSessionUpdate },
    data() {
        return {
            visible: false,
            dataSource: [],
            loading: false,
            form: this.$form.createForm(this),
            pagination: this.initPagination(),
            selectedRowKeys: [],
            columns: [
                {
                    title: this.$t('program.session_name' /* Session名称 */),
                    dataIndex: 'abstract_title',
                    align: 'left',
                    fixed: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.batch_live_label_hall' /* 会场 */),
                    dataIndex: 'meeting_hall',
                    align: 'left'
                },
                {
                    title: this.$t('program.batch_live_label_date' /* 日期 */),
                    dataIndex: 'meeting_date',
                    align: 'left',
                    width: 150
                },
                {
                    title: this.$t('program.time_period' /* 时段 */),
                    dataIndex: 'starttime_slot',
                    scopedSlots: { customRender: 'starttime_slot' },
                    align: 'left',
                    width: 180
                }
            ]
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
            this.getDataList();
        },
        //关闭抽屉
        handleDrawerClose() {
            this.selectedRowKeys = [];
            this.dataSource = [];
            this.pagination = this.initPagination();
            this.form.resetFields();
            this.visible = false;
        },
        // 获取列表数据
        getDataList() {
            let data = {
                ...this.form.getFieldsValue(),
                page: this.pagination.current,
                limit: this.pagination.pageSize
            };
            this.loading = true;
            this.$request
                .get({ url: 'getBatchSessionList', data })
                .then(res => {
                    this.dataSource = res.data.list;
                    this.pagination.total = Number(res.data.count);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // 表格变化
        handleTableChange(pagination) {
            this.selectedRowKeys = [];
            this.pagination.current = pagination.current;
            this.pagination.pageSize = pagination.pageSize;
            this.getDataList();
        },
        // 搜索
        handleSearchEvent() {
            this.selectedRowKeys = [];
            this.pagination.current = 1;
            this.getDataList();
        },
        // 复选框选中
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        // 批量修改
        handleBatchUpdate() {
            if (!this.selectedRowKeys.length) {
                this.$message.warning(this.$t('web.select_at_least_one' /* 请至少选中一条数据 */));
                return false;
            }
            this.$refs.batchSessionUpdate.show(this.selectedRowKeys.join(','));
        },
        initPagination() {
            const pagination = {
                current: 1,
                pageSize: 10,
                total: 0,
                showTotal: total => this.$t('web.pagination_total', { value: total } /*  共 {value} 条 */),
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '30', '50', '100']
            };
            return pagination;
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang='less' scoped>
::v-deep .ant-drawer-body {
    max-height: 90vh;
    overflow-y: auto;
}
</style>